import httpService from "../../Service/httpService";

const controller = "Pacientes";

export const getDatosPaciente = async (id, idPac) => {
  const res = await httpService.get(
    `/${controller}/getDatosPaciente/${id}/${idPac}`,
  );
  return res.data;
};

export const getPacientes = async (id, filtro) => {
  const res = await httpService.get(
    `/${controller}/getPacientes/${id}/${filtro}`,
  );
  return res.data;
};

// Expediente Paciente
export const getExpediente = async (id, idPac) => {
  const res = await httpService.get(
    `/${controller}/getExpediente/${id}/${idPac}`,
  );
  return res.data;
};

export const getEstadosMedicosPac = async (id, idPac) => {
  const res = await httpService.get(
    `/${controller}/getEstadosMedicosPac/${id}/${idPac}`,
  );
  return res.data;
};

export const getNombreDuplicado = async (id, nombre) => {
  const res = await httpService.get(
    `/${controller}/getNombreDuplicado/${id}/${nombre}`,
  );
  return res.data;
};

export const getResumenDocs = async (id) => {
  const res = await httpService.get(
    `/${controller}/getResumenDocs/${id}`,
  );
  return res.data;
};

export const getListPacientes = async (id) => {
  const res = await httpService.get(
    `/${controller}/getListPacientes/${id}`,
  );
  return res.data;
};

export const getConsentimientos = async (id, idPac, doc) => {
  const res = await httpService.get(
    `/${controller}/getConsentimientos/${id}/${idPac}/${doc}`,
  );
  return res.data;
};

export const getFirmaConsentimiento = async (id, idPac, doc) => {
  const res = await httpService.get(
    `/${controller}/getFirmaConsentimiento/${id}/${idPac}/${doc}`,
  );
  return res.data;
};

export const getListaBajas = async (id) => {
  const res = await httpService.get(
    `/${controller}/getListaBajas/${id}`,
  );
  return res.data;
};

export const getListaPacientes = async (id) => {
  const res = await httpService.get(
    `/${controller}/getListaPacientes/${id}`,
  );
  return res.data;
};

export const getExpedPaciente = async (id, idPac) => {
  const res = await httpService.get(
    `/${controller}/getExpedPaciente/${id}/${idPac}`,
  );
  return res.data;
};


export const saveAvisoPriv = async (data) => {
  //   const userData = getDecodedToken();
  const res = await httpService.post(`/${controller}/saveAvisoPriv`, {
    ...data,
  });
  return res;
};

export const saveFirmaMedico = async (data) => {
  //   const userData = getDecodedToken();
  const res = await httpService.post(`/${controller}/saveFirmaMedico`, {
    ...data,
  });
  return res;
};

export const saveConsentHemo = async (data) => {
  //   const userData = getDecodedToken();
  const res = await httpService.post(`/${controller}/saveConsentHemo`, {
    ...data,
  });
  return res;
};

export const saveAplicaHierro = async (data) => {
  //   const userData = getDecodedToken();
  const res = await httpService.post(`/${controller}/saveAplicaHierro`, {
    ...data,
  });
  return res;
};

export const savePaciente = async (data) => {
  //   const userData = getDecodedToken();
  const res = await httpService.post(`/${controller}/saveDatos`, {
    ...data,
  });
  return res;
};